import React from 'react';
import PropTypes from 'prop-types';

import { TextEditor } from '@techchange/components';
import { appPropTypes } from '@techchange/components';

import { RESOURCE_SLIDE_EDITOR_CONFIG } from '../../utils/constants';

const propTypes = {

	/**
	 * The resource id.
	 */
	id: PropTypes.string,

	/**
	 * The content to display.
	 */
	content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

	/**
	 * The appropriate heading level for the slide title based on the
	 * nesting of its parent resources.
	 */
	headingLevel: PropTypes.oneOf([1, 2, 3, 4]).isRequired,

	/**
	 * The title to display.
	 */
	title: PropTypes.string,

	/**
	 * Flag indicating if the content title should be visible.
	 */
	showTitle: PropTypes.bool,

	/**
	 * The scope of this content,
	 * i.e. "session", "course", "organization", etc.
	 */
	scope: PropTypes.string.isRequired,

	/**
	 * The unique scope UUID of this content.
	 */
	scopeId: PropTypes.string.isRequired,

	/**
	 * The settings for filestack to handle image uploads and rendering.
	 */
	filestack: appPropTypes.filestack.isRequired,

	/**
	 * Callback function to handle clicking a link.
	 */
	onLinkClick: PropTypes.func,

};

const ContentDisplay = (props) => {

	const {
		id,
		content,
		headingLevel,
		title,
		showTitle,
		scope,
		scopeId,
		filestack,
		onLinkClick,
	} = props;

	const HeaderTag = `h${headingLevel}`;

	return (
		<div>
			{showTitle &&
				<span className="title">
					<HeaderTag style={{ margin: 0 }}>
						{title}
					</HeaderTag>
				</span>
			}
			<TextEditor
				editorDomId={`pm-editor-${id}`}
				config={RESOURCE_SLIDE_EDITOR_CONFIG}
				emojiSize="24px"
				content={content}
				scope={scope}
				scopeId={scopeId}
				filestackSettings={filestack}
				triggers={{ onLinkClick }}
				readOnly />
		</div>
	);

};

ContentDisplay.propTypes = propTypes;

export default ContentDisplay;
